import FileInfoInstance from './FileInfoInstance.component';

export default FileInfoInstance;